export const environment = {
  production: true,
  appcode: 'INTConn',
  //FOR PROD
  serviceBaseUrl: 'https://in-talentconnect.ey.net/TalentAPI/api/',
  tokenPath: 'https://in-talentconnect.ey.net/TalentAPI/api/Token',
  logoutUrl: 'https://in-talentconnect.ey.net/#/logout',
  sessionExpireUrl: 'https://in-talentconnect.ey.net/#/sessionexpired',
  redirectUri: 'https://in-talentconnect.ey.net/',
  instrumentationKey: 'da37a2a8-0d6c-47e8-8bc8-e7f094c362cf',
  clientId: '3681e44b-4ff2-4e8f-9764-a268274c0626',
  IsHostingEnvAzure: true,
  authURL: 'https://login.microsoftonline.com/5b973f99-77df-4beb-b27d-aa0c70b8482c/oauth2/v2.0/authorize',
  tokenURL: 'https://login.microsoftonline.com/5b973f99-77df-4beb-b27d-aa0c70b8482c/oauth2/v2.0/token',
};

//    //FOR QA-TESTING 
// export const environment = {
//   production: true,
//   appcode: 'INTConn',
//   serviceBaseUrl: 'https://inqa1.ey.com/TalentHelpDesk/TalentAPI/api/',
//   tokenPath: 'https://inqa1.ey.com/TalentHelpDesk/TalentAPI/api/Token',
//   logoutUrl: 'https://inqa1.ey.com/TalentHelpDesk/#/logout',
//   sessionExpireUrl: 'https://inqa1.ey.com/TalentHelpDesk/#/sessionexpired',
//   redirectUri: 'https://inqa1.ey.com/TalentHelpDesk',
//   pageAnalyticsUrl: 'https://inpageanalytics.ey.net/Pages/InsertPageAnalytic.aspx',
//   logPageAnalytics: 'Y',
//   IsHostingEnvAzure: true,
//   authURL: 'https://login.microsoftonline.com/5b973f99-77df-4beb-b27d-aa0c70b8482c/oauth2/v2.0/authorize',
//   tokenURL: 'https://login.microsoftonline.com/5b973f99-77df-4beb-b27d-aa0c70b8482c/oauth2/v2.0/token',
//   clientId: 'd5725004-6099-4182-b476-87df45eac36e',
//   instrumentationKey: 'b5a3470b-8c32-45b3-8250-dd5d5ffddbcb',
 
// };